import { useEffect } from 'react';
import { sendToHost } from 'conversional-iframe-communication';
export function useListener(event, callback) {
    useEffect(function () {
        sendToHost.subscribe(event, callback);
        return function () {
            sendToHost.unsubscribe(event, callback);
        };
    }, []);
}
// Automatically responds to an RPC message when the callback is called
export function useRpcListener(event, callback) {
    function wrappedCallback(payload) {
        callback && callback(payload);
        sendToHost.rpcResolved(payload.id);
    }
    useListener(event, wrappedCallback);
}
export function onEsc(callback) {
    document.onkeydown = function (evt) {
        if (window.fullScreenGalleryImageUrl)
            return;
        evt = evt || window.event;
        if (evt.key == 'Escape' || evt.keyCode == 27) {
            callback();
        }
    };
}
